import { Button, Form, Input } from 'antd'
import { memo, useCallback } from 'react'
import { Document } from 'types/documents'

type Props = {
    data: Document
    onSubmit: (data: Document) => void
    loading: boolean
}

export const DocumentForm = memo((props: Props) => {
    const { data, onSubmit, loading } = props

    const onFinish = useCallback(
        (values: Document) => {
            onSubmit(values)
        },
        [onSubmit]
    )

    return (
        <Form
            name='basic'
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            initialValues={{ remember: true }}
            onFinish={onFinish}
            autoComplete='off'
            disabled={loading}
        >
            <Form.Item
                initialValue={data.title}
                label='Title'
                name='title'
                rules={[{ required: true, message: 'Please input document title!' }]}
            >
                <Input />
            </Form.Item>

            <Form.Item
                initialValue={data.link}
                label='Link'
                name='link'
                rules={[{ required: true, message: 'Please input document link!' }]}
            >
                <Input />
            </Form.Item>
            <Form.Item initialValue={data.image} label='Image' name='image'>
                <Input />
            </Form.Item>
            <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
                <Button type='primary' htmlType='submit'>
                    Submit
                </Button>
                <Button htmlType={'reset'}>Reset</Button>
            </Form.Item>
        </Form>
    )
})
